module.exports = __webpack_public_path__ + "static/media/026-qatar.897a87a1.svg";